import React from 'react';
import { MessageCircle } from 'lucide-react';

const floatingButtonStyle = {
  position: 'fixed',
  bottom: '30px',
  right: '30px',
  width: '64px',
  height: '64px',
  borderRadius: '50%',
  background: 'linear-gradient(135deg, #3f88a5 0%, #3f88a5 100%)',
  color: 'white',
  border: 'none',
  cursor: 'pointer',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  boxShadow: '0 4px 12px rgba(37, 99, 235, 0.4)',
  transition: 'all 0.3s ease',
  zIndex: 999
};

/**
 * Floating "AI Lens" button that opens the AI dashboard.
 */
const AILensButton = ({ onClick }) => (
  <button
    onClick={onClick}
    style={floatingButtonStyle}
    onMouseOver={(e) => {
      e.currentTarget.style.transform = 'scale(1.1)';
      e.currentTarget.style.boxShadow = '0 6px 16px #3f88a5';
    }}
    onMouseOut={(e) => {
      e.currentTarget.style.transform = 'scale(1)';
      e.currentTarget.style.boxShadow = '0 4px 12px #3f88a5';
    }}
    title="AI Lens"
  >
    <div style={{ position: 'relative', display: 'inline-flex', alignItems: 'center', justifyContent: 'center' }}>
      <MessageCircle size={48} />
      <span
        style={{
          position: 'absolute',
          fontSize: '14px',
          fontWeight: 'bold',
          color: 'white',
        }}
      >
        AI
      </span>
    </div>
  </button>
);

export default AILensButton;
